import React, { useEffect, useState } from "react";
import downArrow from "../../../assets/images/downArrow.png";
import upArrow from "../../../assets/images/upArrow1.png";
import { useSelector } from "react-redux";
import { appTheme } from "../../../helpers/utils/Utils";
 
const Accordion = (props) => {
 
  const { title, content, index, expandedIndex, onClick } = props;
  const [openIndex, setOpenIndex] = useState(null);
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const isSmiOneIsTrue = useSelector((state) => state.smiOneAccountTrue);
 
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    onClick(index, content[index]?.category_id);
  };
 
  const handleLinkClick = (event) => {
    const target = event.target;
    event.preventDefault();
    props?.linkClickAction({ link: target.getAttribute("href") });
  };
 
  const extractedTitle = title.split(":")[1];
 
  const isSmiOneFaq = () => {
    return (
      <div>
        {content.map((faq, index) => (
          <div
            key={index}
            className="border-b-2 border-[var(--help-footer-border)] mb-6"
          >
            <button
              type="button"
              id={`accordion-control-${index}`}
              className="w-full pb-6 text-left font-semibold flex justify-between items-center outline-none"
              onClick={() => toggleAccordion(index)}
              aria-expanded={openIndex === index}
              aria-controls={`accordion-content-${index}`}
            >
              <span
                className="font-hanken-grotesk text-[var(--text-clr-transactions)] lg:text-[18px] md:text-[16px] sm:text-[11px] text-[14px] sm:font-bold font-[600] leading-[24px]"
              >
                {faq.title}
              </span>

              <span className="transform transition-transform" aria-hidden="true">
                <img
                  src={openIndex === index ? appThemeData.upArrowIcon : appThemeData.downArrowIcon}
                  alt=""
                  className=""
                />
              </span>
            </button>

            {openIndex === index && (
              <div 
                id={`accordion-content-${index}`}
                className="font-hanken-grotesk text-[var(--accordion-text)] mt-3 lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] font-normal leading-[24px]"
              >
                <div>
                  <div
                    className="sm:py-6 py-5"
                    onClick={handleLinkClick}
                    dangerouslySetInnerHTML={{ __html: faq.description }}
                  />
                  {index !== content.length - 1 && (
                    <div className="md:mb-8 sm:mb-6 mb-4 border-b-2 border-[var(--help-footer-border)]"></div>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };
 
  return isSmiOneIsTrue && !props?.isKudzu
    ? isSmiOneFaq()
    : (
      <div className="border-b-2 border-[var(--help-footer-border)] mb-6">
        <button
          type="button"
          id={`accordion-control-${index}`}
          className="w-full pb-6 text-left font-semibold flex justify-between items-center outline-none"
          onClick={() => toggleAccordion(index)}
          aria-expanded={openIndex === index}
          aria-controls={`accordion-content-${index}`}
        >
          <span
            className="font-hanken-grotesk text-[var(--text-clr-transactions)] lg:text-[18px]
            md:text-[16px] sm:text-[11px] text-[14px] sm:font-bold font-[600]
            leading-[24px]"
          >
            {extractedTitle}
          </span>

          <span className="transform transition-transform" aria-hidden="true">
            <img
              src={openIndex === index ? appThemeData.upArrowIcon : appThemeData.downArrowIcon}
              alt=""
              className=""
            />
          </span>
        </button>

        {openIndex === index && (
          <div 
            id={`accordion-content-${index}`}
            className="font-hanken-grotesk text-[var(--accordion-text)] mt-3 lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] font-normal leading-[24px]"
          >
            {content.map((faq, index) => (
              <div key={index}>
                <p
                  className="font-hanken-grotesk text-[var(--text-clr-transactions)]
                  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] font-normal leading-6"
                >
                  {faq.title}
                </p>
                <div
                  className="sm:py-6 py-5"
                  onClick={handleLinkClick}
                  dangerouslySetInnerHTML={{ __html: faq.description }}
                />
                {index !== content.length - 1 && (
                  <div className="md:mb-8 sm:mb-6 mb-4 border-b-2 border-[var(--help-footer-border)]"></div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
};
 
export default Accordion;